import { UserRound } from "lucide-react";
import { PlaceholderSection } from "@/components/settings/PlaceholderSection";

export function ProfileSection() {
  return <PlaceholderSection id="profile" title="Profile" description="Your name and how you appear in Waggle." icon={<UserRound />} />;
}
